<template>
  <b-modal ref="modal" title="Create Client Feature" lazy>
    <b-form @submit.prevent="submit">
      <validation-summary :errors="errors"></validation-summary>

      <v-form-group :validator="$v.client" label="Client">
        <v-select slot-scope="{ attrs, listeners }"
                  v-model="client"
                  v-bind="attrs"
                  v-on="listeners"
                  :options="clients"
                  placeholder="Client Id"
                  :clearable="false"
                  id="clientId" />
      </v-form-group>

      <v-form-group :validator="$v.feature" label="Feature">
        <v-select slot-scope="{ attrs, listeners }"
                  v-model="feature"
                  v-bind="attrs"
                  v-on="listeners"
                  :options="featureOptions"
                  placeholder="Feature"
                  :clearable="false"
                  id="featureId" />
      </v-form-group>

      <v-form-group v-if="isFeatureDefaultOrderType" :validator="$v.orderType" label="Order Type">
        <v-select slot-scope="{ attrs, listeners }"
                  v-model="orderType"
                  v-bind="attrs"
                  v-on="listeners"
                  :options="orderTypeOptions"
                  placeholder="Order Type"
                  :clearable="false"
                  id="orderTypeId" />
      </v-form-group>

      <v-form-group v-if="isFeatureLabworkType" :validator="$v.labworkType" label="Labwork Type">
        <v-select slot-scope="{ attrs, listeners }"
                  v-model="labworkType"
                  v-bind="attrs"
                  v-on="listeners"
                  :options="labworkTypeOptions"
                  placeholder="Labwork Type"
                  :clearable="false"
                  id="labworkTypeId" />
      </v-form-group>
    </b-form>
    <div slot="modal-footer">
      <b-btn @click="cancel" variant="outline-secondary">Cancel</b-btn>
      <b-btn :loading="loading" variant="success" @click="submit">Create</b-btn>
    </div>
  </b-modal>
</template>

<script>
  import { required, requiredIf } from 'vuelidate/lib/validators';

  import featureService from 'services/feature-service';

  import modalFormMixin from 'mixins/modal-form-mixin';

  import { defaultOrderType, defaultLabworkType } from "@/constants";

  import { createNamespacedHelpers } from 'vuex';
  const { mapState, mapActions } = createNamespacedHelpers('client');

  export default {
    mixins: [modalFormMixin],

    data() {
      return {
        feature: null,
        client: null,
        orderType: null,
        labworkType: null,

        featureOptions: [],
        orderTypeOptions: [],
        labworkTypeOptions: [],
        featuresIdentifierOptions: []
      }
    },

    validations: {
      client: {
        required
      },
      feature: {
        required
      },
      orderType: {
        required: requiredIf(function () { return this.isFeatureDefaultOrderType })
      },
      labworkType: {
        required: requiredIf(function () { return this.isFeatureLabworkType })
      }
    },

    computed: {
      ...mapState(["clients"]),

      orderTypeId() {
        return this.featuresIdentifierOptions.find(f => f.text === defaultOrderType)?.value;
      },

      labworkTypeId() {
        return this.featuresIdentifierOptions.find(f => f.text === defaultLabworkType)?.value;
      },

      isFeatureDefaultOrderType() {
        return this.orderTypeId && this.feature?.value === this.orderTypeId;
      },

      isFeatureLabworkType() {
        return this.labworkTypeId && this.feature?.value === this.labworkTypeId;
      }
    },

    methods: {
      ...mapActions(["getClientsForFilter"]),

      async beforeShow() {
        await this.getClientsForFilter();
        const featureOptionsResponse = await featureService.getFeaturesAsSelectListItems();
        this.featureOptions = featureOptionsResponse.featuresListItems.map(f => {
          return {
            text: f.text,
            label: f.text,
            value: f.value
          }
        });

        this.orderTypeOptions = featureOptionsResponse.orderTypeListItems.map(f => {
          return {
            text: f.text,
            label: f.text,
            value: f.value
          }
        });

        this.labworkTypeOptions = featureOptionsResponse.labworkTypeListItems.map(f => {
          return {
            text: f.text,
            label: f.text,
            value: f.value
          }
        });

        this.featuresIdentifierOptions = featureOptionsResponse.featuresIdentifierList.map(f => {
          return {
            text: f.text,
            label: f.text,
            value: f.value
          }
        });
      },

      async onSubmit() {
        let clientFeature = {};
        let featureValue;
        if (this.isFeatureDefaultOrderType) {
          featureValue = this.orderType?.value;
        } else if (this.isFeatureLabworkType) {
          featureValue = this.labworkType?.value;
        }

        clientFeature.clientId = this.client.value
        clientFeature.featureId = parseInt(this.feature.value);
        clientFeature.featureValue = featureValue;

        await featureService.createClientFeature(clientFeature);
      }
    }
  }

</script>